import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  idToken: string | undefined = undefined;
  setIdToken(idToken: string) {
    this.idToken = idToken;
  }
  getIdToken() {
    return this.idToken;
  }
}
